// src/AutoCRM.js

import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import store from './redux/store';
import SelectorBD from './components/SelectorBD';
import GestorColumnas from './components/GestorColumnas';
import GestorDashboards from './components/GestorDashboards';
import ConstructorColumnas from './components/ConstructorColumnas'; // Importamos el componente ConstructorColumnas
import { fetchGroupData } from './utils/api'; // Ajusta la ruta según sea necesario

// Exponer las funciones para que estén accesibles globalmente (opcional)
window.fetchGroupData = fetchGroupData;

/**
 * Función para montar un componente React en un contenedor específico.
 * @param {HTMLElement} container El elemento del DOM donde se montará el componente.
 * @param {React.Component} component El componente React a montar.
 */
const mountComponent = (container, component) => {
  if (container) {
    try {
      const root = createRoot(container);
      root.render(component);
    } catch (error) {
      console.error('Error al montar el componente React:', error);
    }
  } else {
    console.error('El contenedor especificado no es un elemento del DOM:', container);
  }
};

// Asegúrate de que el DOM esté cargado antes de montar React
document.addEventListener('DOMContentLoaded', function() {
  
  /**
   * Función para montar múltiples instancias del componente GestorDashboards.
   */
  const mountMultipleGestorDashboards = () => {
    // Seleccionar todos los divs cuyo id empiece con 'autocrm-frontend-root-'
    const frontendContainers = document.querySelectorAll('div[id^="autocrm-frontend-root-"]');

    console.log(`Encontrados ${frontendContainers.length} contenedores de GestorDashboards.`);

    frontendContainers.forEach(container => {
      const unique_key = container.getAttribute('data-unique-key');
    
      if (unique_key) {
        console.log(`Cargando GestorDashboards en ${container.id} con unique_key: ${unique_key}`);
        mountComponent(
          container,
          <Provider store={store}>
            <GestorDashboards unique_key={unique_key} />
          </Provider>
        );
      } else {
        console.error(`El contenedor ${container.id} no tiene el atributo 'data-unique-key'.`);
      }
    });
  };

  /**
   * Función para montar componentes en otros contenedores (admin, columnas, dashboards, constructor de columnas).
   */
  const mountOtherComponents = () => {
    // Verifica si estamos en el admin main page buscando el contenedor específico
    const autocrmRoot = document.getElementById('autocrm-root');
    if (autocrmRoot) {
      console.log('Cargando SelectorBD en autocrm-root');
      mountComponent(
        autocrmRoot,
        <Provider store={store}>
          <SelectorBD />
        </Provider>
      );
    }

    // Verifica si estamos en la página del Gestor de Columnas
    const gestorColumnasContainer = document.getElementById('autocrm-columns-root');
    if (gestorColumnasContainer) {
      console.log('Cargando GestorColumnas en autocrm-columns-root');
      mountComponent(
        gestorColumnasContainer,
        <Provider store={store}>
          <GestorColumnas />
        </Provider>
      );
    }

    // Verifica si estamos en la página del Gestor de Dashboards sin unique_key (admin)
    const gestorDashboardsContainer = document.getElementById('autocrm-dashboards-root');
    if (gestorDashboardsContainer) {
      console.log('Cargando GestorDashboards en autocrm-dashboards-root');
      mountComponent(
        gestorDashboardsContainer,
        <Provider store={store}>
          <GestorDashboards />
        </Provider>
      );
    }

    // 🛠️ Verifica si estamos en la página del Constructor de Columnas
    const constructorColumnasContainer = document.getElementById('constructor-columnas');
    if (constructorColumnasContainer) {
      console.log('Cargando ConstructorColumnas en constructor-columnas');
      mountComponent(
        constructorColumnasContainer,
        <Provider store={store}>
          <ConstructorColumnas />
        </Provider>
      );
    }
  };

  // Ejecutar las funciones de montaje
  mountMultipleGestorDashboards();
  mountOtherComponents();

  // Verificar si no se encontraron contenedores compatibles
  const totalGestorDashboards = document.querySelectorAll('div[id^="autocrm-frontend-root-"]').length;
  const hasOtherContainers = document.getElementById('autocrm-root') || 
                              document.getElementById('autocrm-columns-root') || 
                              document.getElementById('autocrm-dashboards-root') ||
                              document.getElementById('constructor-columnas');

  if (totalGestorDashboards === 0 && !hasOtherContainers) {
    console.error('No se encontró ningún contenedor compatible en esta página.');
  }
});
